import { useMemo } from "react";

import { useFinishedSuggestedProjects } from "../../../shared-internal/hooks/use-finished-suggested-projects";
import {
  FeaturedMediumProjectCard,
  FeaturedShortProjectCard,
} from "./featured-project-cards";
import {
  MediumProjectCardSkeleton,
  ShortProjectCardSkeleton,
} from "./featured-project-cards.skeletons";

export function FeaturedFinishedProjects() {
  const { suggestedProjects, isFetching } = useFinishedSuggestedProjects(3);

  const featuredProjects = useMemo(() => {
    if (!suggestedProjects.length) return [];

    return [suggestedProjects[1], suggestedProjects[0], suggestedProjects[2]];
  }, [suggestedProjects]);

  if (isFetching) {
    return (
      <>
        <div className="hidden items-center justify-center lg:flex xl:hidden">
          <MediumProjectCardSkeleton
            className="h-[400px] min-w-[312px] lg:min-w-[312px] lg:max-w-[312px]"
            imgClassName="h-full"
          />
        </div>
        <div className="hidden items-center justify-center gap-x-40 xl:flex">
          <ShortProjectCardSkeleton className="z-0 !min-w-[208px] max-w-[312px] lg:min-w-[208px]" />
          <MediumProjectCardSkeleton className="absolute z-10 min-w-[312px] lg:min-w-[312px] lg:max-w-[312px]" />
          <ShortProjectCardSkeleton className="z-0 !min-w-[208px] max-w-[312px] lg:min-w-[208px]" />
        </div>
      </>
    );
  }

  if (!featuredProjects.length) {
    return null;
  }

  return (
    <>
      {featuredProjects[1] && (
        <div className="hidden items-center justify-center lg:flex xl:hidden">
          <FeaturedMediumProjectCard
            project={featuredProjects[1]}
            className="h-[400px]"
          />
        </div>
      )}
      <div className="hidden items-center justify-center gap-x-40 xl:flex">
        {featuredProjects[0] && (
          <FeaturedShortProjectCard
            project={featuredProjects[0]}
            className="z-0"
          />
        )}
        {featuredProjects[1] && (
          <FeaturedMediumProjectCard
            project={featuredProjects[1]}
            className="absolute z-10"
          />
        )}
        {featuredProjects[2] && (
          <FeaturedShortProjectCard
            project={featuredProjects[2]}
            className="z-0"
          />
        )}
      </div>
    </>
  );
}
